import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { FAMILY_SITUATION } from "utils/constants";
import { downloadUploadedDocument } from "utils/helpers/files";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DocumentUpload from "../Justification/DocumentUpload";
import validation from "./validation";

function View({
  project,
  initialValues,
  onSubmit,
  downloadFile,
  onBack,
  translate,
  onFileRemove: handleFileRemove,
}) {
  const isNotMarried =
    get(project, "contact.fields.familySituation") !== FAMILY_SITUATION.MARRIED;
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const { isValid, handleSubmit, setFieldValue, values, ...formProps } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: onSubmit,
      validationSchema: validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
        { isNotMarried },
      ),
    });

  const createFileRemoveHandler = (fieldName) => async (item) => {
    if (handleFileRemove) {
      await handleFileRemove(fieldName)(item);
      // Remove file from form values immediately
      const currentFiles = values[fieldName] || [];
      const updatedFiles = currentFiles.filter(
        (file) => (file?.uid || file?.id) !== (item?.uid || item?.id),
      );
      setFieldValue(fieldName, updatedFiles);
    }
  };

  const handleDownload = ({ uid, size, base64, contentType, name }) => {
    if (!size) return downloadFile(uid);
    downloadUploadedDocument({
      base64,
      contentType,
      name,
    });
  };

  return (
    <Layout>
      <Header
        title={"Les pièces justificatives de votre conjoint(e)"}
        highlight="Pièces justificatives"
        subtitle="Pièces justificatives du conjoint"
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={14} xl={12}>
          <div className="amellis__documents--container">
            <DocumentUpload
              label={
                translate?.DOCUMENTS?.TYPES?.SOCIAL_SECURITY_CERTIFICATE ||
                "Attestation de sécurité sociale"
              }
              items={values.socialSecurityCertificate}
              onDownload={handleDownload}
              onUpload={(item) => {
                setFieldValue("socialSecurityCertificate", item);
              }}
              onFileRemove={createFileRemoveHandler(
                "socialSecurityCertificate",
              )}
              required={true}
              error={get(formProps.errors, "socialSecurityCertificate")}
            />
            {isNotMarried && (
              <DocumentUpload
                label={"Le justificatif de vie maritale"}
                info={
                  "Le justificatif de vie maritale ou attestation de PACS ou attestation sur l'honneur de concubinage doit être signé par les deux partenaires, ainsi qu'un justificatif de domicile commun."
                }
                items={values.maritalCertificate}
                onDownload={handleDownload}
                onUpload={(item) => {
                  setFieldValue("maritalCertificate", item);
                }}
                onFileRemove={createFileRemoveHandler("maritalCertificate")}
                required={true}
                error={get(formProps.errors, "maritalCertificate")}
              />
            )}
            <div className="recap__wrapper--info">
              <p>Formats de fichiers pris en charge : JPEG, PNG ou PDF</p>
              <p>Taille maximale : 5 Mo</p>
            </div>
          </div>
        </Col>
      </Row>
      <ActionButtons
        disabled={!isEmpty(formProps.errors)}
        onNext={handleSubmit}
        onBack={onBack}
        buttonText={translate?.NEXT || "Suivant"}
      />
    </Layout>
  );
}

export default View;
